<div [formGroup]="form()" class="item-container" [style.display]="isVisible() ? 'flex' : 'none'">
  @if (properties.inputCaptionLeft) {
    <label
      [for]="htmlId()"
      [ngStyle]="getCaptionLeftStyle()"
      [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']"
      [title]="getCaptionLeftTitle()"
      >{{ properties.inputCaptionLeft }}</label
    >
  }
  <div class="input-container second-column">
    <input
      type="text"
      inputmode="decimal"
      [id]="htmlId()"
      [name]="htmlId()"
      [placeholder]="''"
      [formControlName]="formControlId"
      [mask]="mask()"
      [thousandSeparator]="settings().numberFormat.thousandsSeparator"
      [decimalMarker]="settings().numberFormat.decimalSeparator"
      [outputTransformFn]="numberOutputTransform"
      [style]="inputStyle()"
      (change)="onChange($event)"
      (blur)="onBlur($event)" />
    @if (properties.inputCaptionRight) {
      <span>{{ properties.inputCaptionRight }}</span>
    }
    @if (formControl?.errors) {
      <span style="color: red">{{ formControl?.errors | json }}</span>
    }
  </div>
  <ng-content></ng-content>
</div>
